export default __webpack_public_path__ + "16b667067766ac473181750ecacd10b3.png";